// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
/* tslint:disable */
/* eslint-disable */
import "../textstyles/fonts.css";
import "../reset.css";
import "./CreatePickupWindow.LocationsContainer.css";
import React, { createContext, useContext } from "react";
import {
  findSetVariantProps,
  makeCompositeDefaultProps,
} from "../_internal_utils";
import {
  RootPrimitive,
  SpacerPrimitive,
  TextPrimitive,
  ContainerPrimitive,
} from "../_internal_primitives";

const styles = [
  {
    type: "default",
    layers: {
      "8jNmn1kLic": {
        none: {
          text: "Pickup Location",
        },
      },
      RyHxRhpj9X: {
        none: {
          text: "Add a location so customers know where to pickup",
        },
      },
    },
  },
  {
    type: "boolean",
    propName: "isEmpty",
    layers: {},
  },
];

const defaultPropValues = [
  {
    type: "default",
    layers: {},
  },
  {
    type: "boolean",
    propName: "isEmpty",
    layers: {},
  },
];

const variantPropTypes = [
  {
    type: "boolean",
    propName: "isEmpty",
  },
];

export const LocationsContainerContext = createContext(null);

function LocationsContainer(_props) {
  const defaults = useContext(LocationsContainerContext);
  const props = { ...defaults, ..._props };
  const activeVariants = findSetVariantProps(variantPropTypes, props);
  const getCompositeDefaultProps = makeCompositeDefaultProps(
    defaultPropValues,
    activeVariants
  );
  return (
    <RootPrimitive
      {...props}
      key="9gLEetGYXX"
      addSpacing={false}
      internal={{
        projectId: "7X7HTLRqyD",
        styles: styles,
        layerId: "9gLEetGYXX",
        scope: "QWP5FZvASo",
        activeVariants: activeVariants,
      }}
    >
      {(getStyle) => (
        <>
          <TextPrimitive
            id={"Text_8jNmn1kLic"}
            className={
              "__visly_reset_7X7HTLRqyD __visly_scope_QWP5FZvASo_8jNmn1kLic"
            }
            key={"8jNmn1kLic"}
            text={getStyle("8jNmn1kLic", "text")}
            element={getStyle("8jNmn1kLic", "htmlElement")}
          />
          <TextPrimitive
            id={"Text_RyHxRhpj9X"}
            className={
              "__visly_reset_7X7HTLRqyD __visly_scope_QWP5FZvASo_RyHxRhpj9X"
            }
            key={"RyHxRhpj9X"}
            text={getStyle("RyHxRhpj9X", "text")}
            element={getStyle("RyHxRhpj9X", "htmlElement")}
          />
          <SpacerPrimitive
            id={"Spacer_BzDKxS1sLk"}
            className={
              "__visly_reset_7X7HTLRqyD __visly_scope_QWP5FZvASo_BzDKxS1sLk"
            }
            key={"BzDKxS1sLk"}
          />
          <ContainerPrimitive
            key={"DVBC5WUy7f"}
            id={"Slot_DVBC5WUy7f"}
            className={
              "__visly_reset_7X7HTLRqyD __visly_scope_QWP5FZvASo_DVBC5WUy7f"
            }
            addSpacing={true}
          >
            {props.children}
          </ContainerPrimitive>
        </>
      )}
    </RootPrimitive>
  );
}

LocationsContainer.__variants = [
  {
    name: "isEmpty",
    type: "variant",
  },
];

export default LocationsContainer;
